import React from "react";
import { useRouter } from "next/router";

import { colors } from "utils/styles";
import DynamicLink from "./Reusables/DynamicLink";
export default function Badge({
	className = "",
	label = "BADGE",
	color = "yellow",
	fontSize = 15,
	title,
	url,
	releaseDate,
}) {
	const router = useRouter();

	//dynamically make a link to unless the router path includes url
	let href = url && router.asPath.includes(url) ? null : url;
	if (releaseDate && new Date(releaseDate).toISOString() > new Date().toISOString()) {
		href = null;
	}
	return (
		<DynamicLink href={href}>
			<span className={`${color == "none" ? "" : `badge badge-${color}`} ${className}`} title={title}>
				{label}
			</span>

			<style jsx="true">{`
				.badge {
					font-size: ${fontSize}px;
				}
				.badge-yellow {
					color: ${colors.dark};
					background: ${colors.yellow};
				}
				.badge-red {
					color: ${colors.white};
					background: ${colors.red};
				}
				.badge-green {
					color: ${colors.white};

					background: ${colors.green};
				}
				.badge-lightGray {
					color: ${colors.dark};
					background: ${colors.lightGray};
				}
				.badge-lightBlue {
					color: ${colors.white};
					background: ${colors.lightBlue};
				}
				.badge-mediumGray {
					color: ${colors.dark};
					background: ${colors.mediumGray};
				}
				.badge-darkBlue {
					color: ${colors.white};
					background: ${colors.darkBlue};
				}
				.badge-none {
					color: ${colors.black};
					background: ${"none"};
				}

				.badge-Cerulean {
					color: white;
					background: #2d6fa7;
				}
				.badge-Aquamarine {
					color: white;
					background: #32a8a4;
				}
				.badge-Jasper {
					color: white;
					background: #db6048;
				}
				.badge-Purple {
					color: white;
					background: #64548a;
				}
				.badge-Legacy-Gold {
					color: white;
					background: #d7a44d;
				}
				.badge-Royal-Navy {
					color: white;
					background: #142541;
				}
				.badge-Charcoal {
					color: white;
					background: #424242;
				}
				.badge-none {
					color: ${colors.black};
					background: ${"none"};
				}
			`}</style>
		</DynamicLink>
	);
}
